import styled from 'styled-components';

import { Z_INDEX_POPOVER } from '@savgroup-front-common/constants';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $MaintenanceScreen = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: ${Z_INDEX_POPOVER};
`;

export const $GearContainer = styled.div`
  height: ${spacing(52)};
  width: ${spacing(52)};
  z-index: 1;
  position: relative;
  & > *:first-child {
    animation-iteration-count: infinite;

    position: absolute;
    height: ${spacing(52)};
    width: ${spacing(52)};
    color: ${({ theme }) => theme.colors.primary};
    top: calc(-1 * ${spacing(5)});
    left: calc(-1 * ${spacing(5)});
  }
  & > *:last-child {
    animation-iteration-count: infinite;

    animation-direction: reverse;
    bottom: calc(-1 * ${spacing(2.5)});
    right: calc(-1 * ${spacing(2.5)});
    position: absolute;
    height: ${spacing(24)};
    width: ${spacing(24)};
    color: ${({ theme }) => theme.colors.primary};
  }
`;
